import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getSkuListAsync } from 'src/services/costModelling/skuShouldCostWorkbench.services'

const initialState = {
  skuListLoader: false,
  skuListData: [],
  skuListError: '',
}

export const getSkuListDataSlice = createSlice({
  name: 'get-sku-list-data',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getSkuListAsync.pending), (state) => {
      state.skuListLoader = true
      state.skuListError = ''
    })
    builder.addMatcher(isAnyOf(getSkuListAsync.fulfilled), (state, action) => {
      state.skuListLoader = false
      state.skuListData = action.payload?.data || []
      state.skuListError = ''
    })
    builder.addMatcher(isAnyOf(getSkuListAsync.rejected), (state, action) => {
      state.skuListLoader = false
      state.skuListError = action?.payload?.message || 'Failed to fetch SKU data'
    })
  },
  reducers: {
    clearSkuListData: (state) => {
      state.skuListData = []
      state.skuListError = ''
    },
  },
})

export const { clearSkuListData } = getSkuListDataSlice.actions
export default getSkuListDataSlice.reducer 